import React, { useEffect, useState } from "react";
import AddFAQ from "../components/Faq/AddFAQ";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import { getStaticContent } from "../features/slices/staticContentManagement";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ContentManagement from "../components/contentManagement/ContentManagement";
import { getFAQ } from "../features/slices/faqManagement";
import FAQ from "../components/contentManagement/FAQ";

const StaticContentManagement = () => {
  const dispatch = useDispatch();
  const { content, loading } = useSelector((state) => state?.staticContent);

  useEffect(() => {
    dispatch(getStaticContent({ type: "All" }));
    dispatch(getFAQ());
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Content Management System</h4>
            </div>
            <div className="StaticBox">
              <FAQ />
              {content?.staticResult?.map((data) => {
                return <ContentManagement data={data} key={data?._id} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaticContentManagement;
